exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-444ab782]{font-size:18px;text-align:center;width:100%;font-weight:700;padding-bottom:12px;border-bottom:1px solid #d9e0e6}.item[data-v-444ab782]{font-size:14px;margin-top:15px}.ivu-input-wrapper[data-v-444ab782]{margin-top:15px}.i-title[data-v-444ab782]{margin-top:15px;font-size:15px;width:100%;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-444ab782","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/bloodRecord/index.vue
// module id = xjLO
// module chunks = 0